module.exports = __webpack_public_path__ + "assets/img/18_1826.af1775c1.jpg";